var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-2 -1 49 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cross-cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cross-cls-2 {\r\n        fill: #93378a;\r\n      }\r\n    "))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cross-cls-1",
    d: "M 39.087 10.175 L 23.483 1.163 C 12.585 -5.124 -1.048 2.745 -1.048 15.33 L -1.048 33.344 C -1.048 45.94 12.585 53.81 23.483 47.512 L 39.087 38.51 C 49.996 32.212 49.996 16.473 39.087 10.175 Z",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cross-cls-1",
    d: "M 36.914 11.833 L 23.378 4.014 C 13.923 -1.441 2.096 5.387 2.096 16.305 L 2.096 31.932 C 2.096 42.86 13.923 49.686 23.378 44.223 L 36.914 36.414 C 46.378 30.95 46.378 17.296 36.914 11.833 Z",
    style: {}
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cross-cls-2",
    d: "m28.6,29.9l-5.68-5.68,5.68-5.68c.65-.65.65-1.7,0-2.35s-1.7-.65-2.35,0l-5.68,5.68-5.68-5.68c-.65-.65-1.7-.65-2.35,0-.65.65-.65,1.7,0,2.35l5.68,5.68-5.68,5.68c-.65.65-.65,1.7,0,2.35s1.7.65,2.35,0l5.68-5.68,5.68,5.68c.65.65,1.7.65,2.35,0s.65-1.7,0-2.35Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.7cd4b7d10b3525b41b8dfdabab36e9be.svg";
export { ForwardRef as ReactComponent };